import { Base } from '@studiometa/js-toolkit';
import { nextFrame } from '@studiometa/js-toolkit/utils';

/**
 * FilterTabs component
 */
export default class FilterTabs extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'FilterTabs',
    options: {
      endpoint: {
        type: String,
        default: '',
      },
    },
  };

  /**
   * mounted
   */
  mounted() {
    if (this.$options.endpoint) {
      this.fetchTemplate(this.$options.endpoint);
    }
  }

  /**
   * Fetch <option> from API
   * @this {Select & SelectInterface}
   * @param {string} endpoint
   */
  async fetchTemplate(endpoint) {
    const tpl = await fetch(endpoint).then((response) => {
      return response.text();
    });

    this.$el.innerHTML = tpl;

    nextFrame(() => {
      this.$root.$update();
    });
  }
}
